import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Form, Radio, Button } from 'antd';

function CommTypeForm({
  formData,
  // actions
  nextStep,
  prevStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames('form-communication', className);

  const [isDisabled, setIsDisabled] = useState(true);

  const [CommFormType] = Form.useForm();

  /* 
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (formData && formData?.type) {
      CommFormType.setFieldsValue(formData);
      setIsDisabled(false);
    }
  }, [formData]);

  const onFinish = values => {
    !!result && result(values);
    !!nextStep && nextStep();
    CommFormType.resetFields();
  };

  const options = [
    {
      key: 'absence',
      value: 'absence',
      label: (
        <>
          <span className="label__title">
            Une demande d’absence
          </span>
          <span className="label__description">
            Absence médicale, non-médicale ou maladie
          </span>
        </>
      ),
    },
    {
      key: 'custom',
      value: 'custom',
      label: (
        <>
          <span className="label__title">
            Une autre requête
          </span>
          <span className="label__description">
            Demande d’information, rendez-vous, divers, …
          </span>
        </>
      ),
    },
  ];

  return (
    <div className={childClassName}>
      <Form
        form={CommFormType}
        className="form-communication__form"
        name="form_communication_type"
        initialValues=""
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <Form.Item name="type">
          <Radio.Group
            className="radio-group radio-group--big"
            options={options}
            optionType="Radio"
          />
        </Form.Item>

        <div className="communication-actions-wrapper">
          <Button
            className="next-btn"
            form="form_communication_type"
            htmlType="submit"
            disabled={isDisabled}
          >
            Suivant
          </Button>
        </div>
      </Form>
    </div>
  );
}

CommTypeForm.defaultProps = {};
CommTypeForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
};

export default memo(CommTypeForm);
